import { useSearchParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { track } from "@/lib/track";
import MarktplatzWidget from "@/components/MarktplatzWidget";
import MarktplatzWidgetLive from "@/components/MarktplatzWidgetLive";

const Phone = ({ label, children }) => (
  <div className="mp-dual-col">
    <div className="mp-dual-label">{label}</div>
    <div className="phone">
      <span className="phone-notch" />
      <div className="phone-screen">
        <div className="phone-content">{children}</div>
      </div>
    </div>
  </div>
);

export default function WidgetStandalone() {
  const [params] = useSearchParams();
  const simulate = params.get("simulate") === "true";
  const ssg = params.get("ssg") === "1" || params.get("ssg") === "true";
  const dual = params.get("dual") === "true";

  useEffect(() => {
    track(dual ? "view_dual" : simulate ? "view_simulation" : "view_live");
  }, [dual, simulate]);

  if (dual) {
    return (
      <div className="mp-standalone mp-dual" data-testid="widget-dual">
        <Link to="/" className="mp-back" data-testid="back-link">
          <ArrowLeft size={14} /> Dashboard
        </Link>
        <div className="mp-dual-grid">
          <Phone label="Live · MWS Terrorsperre">
            <MarktplatzWidgetLive />
          </Phone>
          <Phone label="Simulation">
            <MarktplatzWidget ssg={ssg} />
          </Phone>
        </div>
      </div>
    );
  }

  return (
    <div className="mp-standalone" data-testid="widget-standalone">
      <Link to="/" className="mp-back" data-testid="back-link">
        <ArrowLeft size={14} /> Dashboard
      </Link>
      <span className="mp-mode-tag" data-testid="mode-tag">
        {simulate ? "Simulation" : "Live · MWS"}
      </span>
      {simulate ? <MarktplatzWidget ssg={ssg} /> : <MarktplatzWidgetLive />}
    </div>
  );
}
